import { removeToken } from "./services/auth";
import { useHistory } from "react-router-dom";

export const Logout = () => {
  const history = useHistory();
  removeToken();
  history.replace("/login");
  history.go();
};
